/* Dashboard shortcut: the user's own pending parcels (allotted services) → worklist in a new tab. */
import { useEffect, useState } from "react";
import axios from "axios";
import { ArrowUpRight, ListChecks } from "lucide-react";
import { API, getAuthHeader } from "@/App";
import { openPage } from "@/components/BackBar";

let cache = { at: 0, d: null, p: null };  // Dashboard remounts this card often — reuse for 60s, one request at a time
export const MyWorklistCard = () => {
  const [d, setD] = useState(cache.uid === JSON.parse(localStorage.getItem("user") || "{}").id ? cache.d : null);
  useEffect(() => {
    const uid = JSON.parse(localStorage.getItem("user") || "{}").id;
    if (cache.uid !== uid) cache = { at: 0, d: null, p: null, uid };
    if (cache.d && Date.now() - cache.at < 60000) return;
    cache.p = cache.p || axios.get(`${API}/order-register/pending-service-report`, { params: { pbu: 1, age: "total" }, headers: getAuthHeader() })
      .then(r => { cache = { at: Date.now(), d: r.data, p: null, uid }; return r.data; })
      .catch(() => { cache.p = null; return null; });
    let live = true;
    cache.p.then(v => { if (live) setD(v); });
    return () => { live = false; };
  }, []);
  if (!d) return null;
  return (
    <button type="button" data-testid="my-worklist-card"
      onClick={() => openPage("/pending-worklist?bucket=ALL&age=total")}
      className="group flex w-full items-center gap-4 rounded-xl border border-indigo-200 bg-white/80 p-4 text-left shadow-lg transition-colors hover:border-indigo-400 hover:bg-indigo-50/60">
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-indigo-100"><ListChecks className="h-6 w-6 text-indigo-600" /></div>
      <div className="flex-1">
        <p className="text-sm font-semibold text-slate-800">My pending worklist</p>
        <p className="text-xs text-slate-600" data-testid="my-worklist-count">
          <b className="text-lg text-slate-900">{d.total_parcels}</b> parcels · <b className="text-red-600">{d.total_over_48h}</b> over 48h · your services
        </p>
      </div>
      <ArrowUpRight className="h-5 w-5 text-indigo-500 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
    </button>
  );
};
